import { Outlet, createFileRoute } from '@tanstack/react-router';
import { Spinner } from '../components/ui/spinner';
import { SidebarInset, SidebarProvider } from '../components/ui/sidebar';
import { AppSidebar } from '../components/layout/AppSidebar';
import { AppTopbar } from '../components/layout/AppTopbar';
import { Toaster } from '../components/ui/sonner';
import { TooltipProvider } from '../components/ui/tooltip';
import { IdleWarning } from '../components/auth/IdleWarning';
import { requireAuth } from '../lib/auth/guards';

function AppLayout() {
  return (
    <TooltipProvider delayDuration={300}>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>
          <AppTopbar />
          <div className="flex-1 overflow-y-auto">
            <Outlet />
          </div>
          <IdleWarning />
        </SidebarInset>
        <Toaster position="top-right" richColors />
      </SidebarProvider>
    </TooltipProvider>
  );
}

function AppPending() {
  return (
    <div className="min-h-screen flex items-center justify-center text-slate-500">
      <Spinner className="h-6 w-6" />
    </div>
  );
}

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    await requireAuth(context.queryClient, location.pathname);
  },
  component: AppLayout,
  pendingComponent: AppPending,
});
